import React from 'react'

import { isAlive } from '@jbrowse/mobx-state-tree'
import { observer } from 'mobx-react'

import { renderMouseover } from './renderMSAMouseover.ts'
import { useCanvasAutorun } from '../../useCanvasAutorun.ts'

import type { MsaViewModel } from '../../model.ts'

const MSAMouseoverCanvas = observer(function ({
  model,
}: {
  model: MsaViewModel
}) {
  const { height, msaAreaWidth, verticalScrollbarWidth, highResScaleFactor } =
    model
  const width = msaAreaWidth - verticalScrollbarWidth
  const ref = useCanvasAutorun(
    ctx => {
      if (isAlive(model)) {
        renderMouseover({ ctx, model })
      }
    },
    [model],
  )

  return (
    <canvas
      ref={ref}
      id="mouseover"
      width={width * highResScaleFactor}
      height={height * highResScaleFactor}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width,
        height,
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    />
  )
})

export default MSAMouseoverCanvas
